import { Injectable } from '@angular/core';
import { PaginatedResponse, ResourceService, ServerResponse } from '@core/resources/resource.service';
import { HttpClient } from '@angular/common/http';
import { Pagination, PaginationStoreService } from '@core/resources/pagination.service';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeSerializer } from './theme.serializer';
import { Theme, ThemeIO } from './theme';
import { QueryOptions } from '@core/resources/query-options.service';
import { Observable } from 'rxjs/internal/Observable';
import { ThemesStoreService } from './themes.store.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { Category, CategoryIO } from '../category/category';
import { Resource } from '@core/resources/resource';
import { EnvironmentService } from '@core/domains/environment/environment.service';

@Injectable()
export class ThemesService extends ResourceService<Theme> {
  private _apiBaseUrl: string;
  constructor(
    protected env: EnvironmentService,
    protected override httpClient: HttpClient,
    protected override pageStore: PaginationStoreService,
    private store: ThemesStoreService,
    loco: TranslocoService) {
    super(
      env,
      httpClient,
      'filtering/v1/categorize',
      'catalog/themes',
      new ThemeSerializer(loco.getActiveLang()),
      pageStore
    );
    this._apiBaseUrl = `${this.env.environment.api_domain}`;
  }

  get apiBaseUrl() : string {
    return this._apiBaseUrl;
  }

  override list(queryOptions: QueryOptions<Pagination> = new QueryOptions<Pagination>({limit: 10000})): Observable<PaginatedResponse<Theme>> {
    const url = queryOptions ? `${this._apiBaseUrl}/${this.api}/${this.endpoint}/${queryOptions.toQueryString()}` : `${this._apiBaseUrl}/${this.api}/${this.endpoint}/`;

    return this.httpClient.get<ServerResponse<ThemeIO>>(url).pipe(
      tap((result: ServerResponse<ThemeIO>) => this.store.rawData = result.results),
      map((response: ServerResponse<ThemeIO>) => {
        const page = new Pagination({next: null, previous: null, limit: 10000, count: response.count});
        return response.results.length === 0 ? {page, results: [] as Theme[]} : {page, results: this.convertData(response.results)};
      }),
      tap(({results}) => this.store.setThemes(results))
    );
  }

  getThemeByUrl(urlToCategorize: string): Observable<Theme | undefined> {
    const url = `${this._apiBaseUrl}/${this.api}/urltester/`;
    const body = {"url_to_categorize": urlToCategorize};

    return this.httpClient.post<Resource>(url, body).pipe(
      map((response: Resource) => {
        return this.getThemeByCategoryId(response.id);
      })
    );
  }

  getThemeByCategoryId(category_id: string): Theme | undefined{

    const theme = this.store.rawData.find((th: ThemeIO) => th.categories.find((cate: CategoryIO) => cate.id.toString() === category_id));

    if(theme){
      const result: Theme = this.serializer.fromJson(theme);
      const category = result.categories.find((cat: Category): cat is Category => category_id === cat.id.toString());
      if(category){
        result.select(category);
      }
      return result;
    }

    return undefined;
  }
}

